import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import validateSettingsReducer, { initialState } from '../reducers/validateSettingsReducer';

export const ValidateSettingsContext = createContext();

const ValidateSettingsProvider = ({ children }) => {
  const useValidateSettingsState = useReducer(validateSettingsReducer, initialState);

  return (
    <ValidateSettingsContext.Provider value={[...useValidateSettingsState]}>
      <ContextDevTool
        context={ValidateSettingsContext}
        id="ValidateSettingsContext"
        displayName="ValidateSettings Context"
      />
      {children}
    </ValidateSettingsContext.Provider>
  );
};

ValidateSettingsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ValidateSettingsProvider;
